/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.5.0",
  "gitBuildTime": "2026-05-12T15:12:14.632Z",
  "gitBuildVersion": "1.5.0",
  "gitCommitId": "f0b6738",
  "gitCommitIdFull": "f0b67384b85e1d9f4bc549da5de73def21d28c3f",
  "gitCommitTime": "2026-05-12T15:10:47.000Z",
  "version": "1.5.0-2026-05-12T15:10:47.000Z-(f0b6738)"
};
